import PageSection from 'components/PageSection';
import { Body1, SectionTitle } from 'components/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SolutionSectionFour = () => {
    const { t } = useTranslation('solutionDataCentre');
    return (
        <PageSection containerClass="py-16 md:py-32" className="border-b-1 border-neutral">
            <div className="w-full lg:w-1/2">
                <SectionTitle className="fade-in-scroll">{t('sectionFour.title')}</SectionTitle>
            </div>
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-16 mt-16">
                <div className="flex-1">
                    <Body1 className="fade-in-scroll">{t('sectionFour.body1')}</Body1>
                </div>
                <div className="flex-1">
                    <Body1 className="fade-in-scroll">{t('sectionFour.body2')}</Body1>
                </div>
            </div>
        </PageSection>
    );
};

export default SolutionSectionFour;
